import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-user-role-dialog',
  templateUrl: './user-role-dialog.component.html',
  styleUrls: ['./user-role-dialog.component.css'],
})
export class UserRoleDialogComponent {
  availableRoles: string[];
  selectedRole: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<UserRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { name: string; rolesFiltrados: string[] }
  ) {
    this.availableRoles = data.rolesFiltrados;
  }

  onSave(): void {
    this.dialogRef.close(this.selectedRole);
  }
}
